const PROXY_URL = 'apps/salepify';
class DiscountsApplyOnVariant {
    constructor(variants, customerTags, product, isLoggedIn) {
        this.variants = variants;
        this.customerTags = customerTags;
        this.product = product;
        this.isLoggedIn = isLoggedIn;
        this.discountsGroup = [];
        this.addToCartData = [];

        this.discountsContainerHTML = document.querySelector("#list-discount");
        this.tlDiscountContainer = document.getElementById("tl-discount-container");
        this.getDiscountRule().then(() => {
            this.renderDiscountBoard()
        });
        this.currencyRate = 1;
        if (Shopify && Shopify.currency) {
            this.currency = Shopify.currency.active;
            this.currencyRate = Number(Shopify.currency.rate);
        }
        this.chooseDefaultDeal = false;
        this.defaultDiscountStyle = {
            textFields: {
                heading: null,
                discountFormatText: 'Buy {quantity} you save {discount}{currency}',
                popularHighlightText: 'popular',
                addToCartText: 'Grab discount'
            },
            heading: {
                textSize: 14,
                textWeight: '600',
                textColor: '#4e4e4e',
                align: 'center',
                marginBottom: 10,
            },
            general: {
                textSize: 14,
                textWeight: '400',
                textColor: '#303030',
                backgroundColor: '#e6f5f4',
                borderType: 'solid',
                borderColor: '#b2b2d9',
                selectedBorderColor: '#000080',
                borderWidth: 1,
                borderRadius: 16,
                selectedBorderWidth: 2
            },
            highlight: {
                textSize: 14,
                textWeight: '400',
                align: 'center',
                textColor: '#123452',
                backgroundColor: '#764534',
                borderWidth: 1,
                selectedBorderWidth: 2,
            },
            buttonGrabDiscount: {
                textSize: 16,
                textWeight: '400',
                textColor: '#ffffff',
                backgroundColor: '#554ec3',
                shadowColor: '#3d3b57'
            }
        }
    }

    async getDiscountRule() {
        let listIds = this.variants.map((variant) => variant.id);
        let response = await fetch(window.Shopify.routes.root + `${PROXY_URL}/discount`,{
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                ids: listIds.join(","),
                customerTags: this.customerTags.join(","),
                productTags: this.product.tags.join(","),
                productName: this.product.title,
                priceRange: `${this.product.priceMin},${this.product.priceMax}`,
                collectionIds: this.product.collections.join(",")
            })
        });

        let discountsJson = await response.json();
        if (discountsJson.success) {
            this.discountsGroup = discountsJson.data.rulesApplyOnVariant;
            for (let i = 0; i < this.discountsGroup.length; i++) {
                let displaySettings = this.discountsGroup[i].display_settings ? JSON.parse(this.discountsGroup[i].display_settings) : this.defaultDiscountStyle;
                if (displaySettings.textFields.heading) {
                    this.discountsGroup[i].title = displaySettings.textFields.heading;
                }
                if (displaySettings.textFields.addToCartText) {
                    this.discountsGroup[i].addToCartText = displaySettings.textFields.addToCartText;
                }
                for (let j = 0; j < this.discountsGroup[i].discountTiers.length; j++) {
                    let txt = displaySettings.textFields.discountFormatText;
                    let replaceQuantityText = txt.replace('{quantity}', `${this.discountsGroup[i].discountTiers[j].minimum}`);
                    let replaceDiscountText = replaceQuantityText.replace('{discount}', `${parseFloat(this.discountsGroup[i].discountTiers[j].off*this.currencyRate).toFixed(2)}`);
                    let replaceCurrencyText = replaceDiscountText.replace('{currency}', this.discountsGroup[i].value_type === "percentage" ? '%' : this.currency)
                    this.discountsGroup[i].discountTiers[j].inforText = replaceCurrencyText;
                }

            }
        }
    }

    formatMoney = function (t, e = `{{amount_with_period_and_space_separator}} ${this.currency}`) {
        function n(t, e) {
            return void 0 === t ? e : t
        }

        function o(t, e, o, i) {
            if (e = n(e, 2), o = n(o, ","), i = n(i, "."), isNaN(t) || null == t) return 0;
            var r = (t = (t / 100).toFixed(e)).split(".");
            return r[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + o) + (r[1] ? i + r[1] : "")
        }
        "string" == typeof t && (t = t.replace(".", ""));
        var i = "",
            r = /\{\{\s*(\w+)\s*\}\}/,
            a = e || this.money_format;
        switch (a.match(r)[1]) {
            case "amount":
                i = o(t, 2);
                break;
            case "amount_no_decimals":
                i = o(t, 0);
                break;
            case "amount_with_comma_separator":
                i = o(t, 2, ".", ",");
                break;
            case "amount_with_space_separator":
                i = o(t, 2, " ", ",");
                break;
            case "amount_with_period_and_space_separator":
                i = o(t, 2, " ", ".");
                break;
            case "amount_no_decimals_with_comma_separator":
                i = o(t, 0, ".", ",");
                break;
            case "amount_no_decimals_with_space_separator":
                i = o(t, 0, " ");
                break;
            case "amount_with_apostrophe_separator":
                i = o(t, 2, "'", ".")
        }
        return a.replace(r, i)
    }


    selectDeal(tierMinimum, discountId, tierOff = 0, discountType, appliesTo) {
        this.addToCartData = [];
        if (this.variants.length === 1) {
            this.addToCartData.push({
                id: this.variants[0].id,
                quantity: tierMinimum
            })
            // this.grabDiscountButton.style.display = "block";
            let buttons = document.querySelectorAll(".tl-discounts-grab-button");
            buttons.forEach(ele => ele.style.display = "none");
            document.querySelector(`.tl-grab-discount-btn-${discountId}-${tierMinimum}`).style.display = "flex";
        } else {
            let realPrice = 0;
            let discountedPrice;
            document.querySelectorAll(".tl-discount-variants-list").forEach(ele => ele.style.display = "none");
            document.querySelectorAll(".tl-discount-variants-list > option").forEach(ele => ele.style.display = "none");
            document.querySelectorAll(`.tl-discount-item-index`).forEach(ele => ele.style.display = "none");

            document.querySelectorAll(`.tl-discount-variants-list-${discountId}-${tierMinimum}`).forEach(ele => {
                this.variants.map((variant) => {
                    if (variant.id === ele.value) {
                        realPrice += +variant.price;
                    }
                })
                ele.style.display = "block";
                this.addToCartData.push({
                    id: ele.value,
                    quantity: appliesTo === 'variants' ? tierMinimum : 1
                })
            });
            if (discountType === "percentage") {
                discountedPrice = realPrice * (100 - +tierOff) / 100;
            }
            else {
                discountedPrice = realPrice - (+tierOff)*this.currencyRate * 100;
            }

            if (discountedPrice < 0) discountedPrice = 0;

            document.querySelectorAll(`.tl-discount-item-${discountId}-${tierMinimum}`).forEach(ele => ele.style.display = "inline");
            document.querySelectorAll(`.tl-discount-variants-choices-${discountId}-${tierMinimum}`).forEach(ele => ele.style.display = "block");
            // this.grabDiscountButton.style.display = "block";
            let buttons = document.querySelectorAll(".tl-discounts-grab-button");
            buttons.forEach(ele => ele.style.display = "none");
            document.querySelector(`.tl-grab-discount-btn-${discountId}-${tierMinimum}`).style.display = "flex";

            document.querySelector(`.tl-discounts-total-del-price-${discountId}-tier-${tierMinimum}`).innerHTML = this.formatMoney(realPrice);
            document.querySelector(`.tl-discounts-total-price-${discountId}-tier-${tierMinimum}`).innerHTML = this.formatMoney(discountedPrice);;
        }
    }

    addVariantToCart() {
        let formData = {
            'items': this.addToCartData.map((variant) => {
                return {
                    'id': parseInt(variant.id),
                    'quantity': parseInt(variant.quantity)
                }
            })
        };

        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
            .then(() => {
                window.location.href = "/cart";
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    changeStyleRadioButton(discountId, minimum) {
        let labels = document.querySelectorAll(".label-tl-discount");
        labels.forEach(ele => {
            ele.style.border = "var(--discount-preview__general__border-width) var(--discount-preview__general__border-type) var(--discount-preview__general__border-color)";
            ele.childNodes[1].childNodes[3].style.background = "#fff";
            ele.childNodes[1].childNodes[3].style.outline = "2px solid var(--discount-preview__general__border-color)";
        })
        let selectedLabel = document.querySelector(`.label-for-${discountId}-tier-${minimum}`);
        selectedLabel.style.border = "var(--discount-preview__general__selected-border-width) var(--discount-preview__general__border-type) var(--discount-preview__general__selected-border-color)";
        selectedLabel.childNodes[1].childNodes[3].style.background = "var(--discount-preview__general__selected-border-color)";
        selectedLabel.childNodes[1].childNodes[3].style.outline = "2px solid var(--discount-preview__general__selected-border-color)";
    }

    changeStyle(displaySettings) {
        let generalSettings = displaySettings.general;
        let headingSettings = displaySettings.heading;
        let buttonGrabDiscountSettings = displaySettings.buttonGrabDiscount;

        document.documentElement.style.setProperty('--discount-preview__general__background', generalSettings.backgroundColor);
        document.documentElement.style.setProperty('--discount-preview__general__border-color', generalSettings.borderColor);
        document.documentElement.style.setProperty('--discount-preview__general__border-type', generalSettings.borderType);
        document.documentElement.style.setProperty('--discount-preview__general__text-color', generalSettings.textColor);
        document.documentElement.style.setProperty('--discount-preview__general__text-size', `${generalSettings.textSize}px`);
        document.documentElement.style.setProperty('--discount-preview__general__text-weight', generalSettings.textWeight);
        document.documentElement.style.setProperty('--discount-preview__general__border-width', `${generalSettings.borderWidth}px`);
        document.documentElement.style.setProperty('--discount-preview__general__selected-border-width', `${generalSettings.selectedBorderWidth}px`);
        document.documentElement.style.setProperty('--discount-preview__general__selected-border-color', generalSettings.selectedBorderColor);
        document.documentElement.style.setProperty('--discount-preview__general__border-radius', `${generalSettings.borderRadius}px`);

        document.documentElement.style.setProperty('--discount-preview__grab-button__text-size', `${buttonGrabDiscountSettings.textSize}px`);
        document.documentElement.style.setProperty('--discount-preview__grab-button__text-color', buttonGrabDiscountSettings.textColor);
        document.documentElement.style.setProperty('--discount-preview__grab-button__text-weight', buttonGrabDiscountSettings.textWeight);
        document.documentElement.style.setProperty('--discount-preview__grab-button__background-color', buttonGrabDiscountSettings.backgroundColor);
        document.documentElement.style.setProperty('--discount-preview__grab-button__box-showdow-color', buttonGrabDiscountSettings.shadowColor);

        try {
            let titles = document.querySelectorAll(".tl-discount-title");
            for (let i = 0; i < titles.length; i++) {
                if (headingSettings.align === "left") {
                    titles[i]?.classList.remove("tl-discount-title-before");
                    titles[i]?.classList.add("tl-discount-title-after");
                } else if (headingSettings.align === "right") {
                    titles[i]?.classList.remove("tl-discount-title-after");
                    titles[i]?.classList.add("tl-discount-title-before");
                } else {
                    titles[i]?.classList.add("tl-discount-title-before");
                    titles[i]?.classList.add("tl-discount-title-after");
                }
            }
            document.documentElement.style.setProperty('--discount-preview__heading__text-size', `${headingSettings.textSize}px`);
            document.documentElement.style.setProperty('--discount-preview__heading__text-weight', headingSettings.textWeight);
            document.documentElement.style.setProperty('--discount-preview__heading__text-color', headingSettings.textColor);
            document.documentElement.style.setProperty('--discount-preview__heading__margin-bottom', `${headingSettings.marginBottom}px`);
        } catch (e) {
            console.log("Update heading settings error", e)
        }


    }

    renderDiscountBoard() {
        if (this.discountsGroup.length && this.variants.length) {
            this.tlDiscountContainer.style.display = "block";
            this.discountsContainerHTML.innerHTML = "";
            let discountsHTML = "";

            this.discountsGroup.map((discount) => {
                if (discount.layout_type === "allow_interact") {
                    let discountHTML = `<div class="tl-discount-tier-container">
                                    <p class="tl-discount-title">${discount.title}</p>`;
                    if (discount.customer_eligibility_type === "logged-in" && !this.isLoggedIn) {
                        discountHTML += `<div>\
                                            <a href='${window.Shopify.routes.root}account/login'>Log in to get this discount</a>\
                                        </div>`
                    } else {
                        discount.discountTiers.map((tier) => {
                            let variantsChoiceList = "";

                            if (this.variants.length > 1) {
                                if (discount.applies_to === 'product-price') {
                                    let satisfiedVariants = [];
                                    for (let i = 0; i < this.variants.length; i++) {
                                        if (discount.product_price_condition === 'and') {
                                            if (
                                                parseInt(this.variants[i].price) / 100 > discount.product_price_greater_than &&
                                                parseInt(this.variants[i].price) / 100 < discount.product_price_less_than) {
                                                satisfiedVariants.push(this.variants[i]);
                                            }
                                        }
                                        else {
                                            if (discount.product_price_greater_than > 0 && parseInt(this.variants[i].price) / 100 > discount.product_price_greater_than) {
                                                satisfiedVariants.push(this.variants[i]);
                                            }
                                            else if (discount.product_price_less_than > 0 && parseInt(this.variants[i].price) / 100 < discount.product_price_less_than) {
                                                satisfiedVariants.push(this.variants[i]);
                                            }
                                        }
                                    }
                                    for (let i = 0; i < tier.minimum; i++) {
                                        let variantsChoiceItem = `<div class="tl-discount-item-list">
                                                            <span style="display:none" class="tl-discount-item-index tl-discount-item-${discount.id}-${tier.minimum}">Item #${i + 1}</span>
                                                            <select style="display: none" onchange="window.tlDiscounts.selectDeal(${tier.minimum}, \'${discount.id}\', ${tier.off}, \'${discount.value_type}\')" class="tl-discount-variants-list tl-discount-variants-list-${discount.id}-${tier.minimum}">`
                                        satisfiedVariants.map((variant) => variantsChoiceItem += `<option class="tl-discount-variants-choices-${discount.id}-${tier.minimum}" value="${variant.id}">${variant.title}</option>`)
                                        variantsChoiceItem += "</select></div>";
                                        variantsChoiceList += variantsChoiceItem;
                                    }
                                }
                                else if (discount.applies_to === 'variants') {
                                    let variantsChoiceItem = `<div class="tl-discount-item-list">
                                        <span style="display:none" class="tl-discount-item-index tl-discount-item-${discount.id}-${tier.minimum}">Buy ${tier.minimum}</span>
                                        <select style="display: none" onchange="window.tlDiscounts.selectDeal(${tier.minimum}, \'${discount.id}\', ${tier.off}, \'${discount.value_type}\' , \'${discount.applies_to}\')" class="tl-discount-variants-list tl-discount-variants-list-${discount.id}-${tier.minimum}">`
                                    this.variants.map((variant) => {
                                        if(discount.variant_ids.includes(variant.id)){
                                            variantsChoiceItem += `<option class="tl-discount-variants-choices-${discount.id}-${tier.minimum}" value="${variant.id}">${variant.title}</option>`
                                        }
                                    })
                                    variantsChoiceItem += "</select></div>";
                                    variantsChoiceList += variantsChoiceItem;
                                }
                                else {
                                    for (let i = 0; i < tier.minimum; i++) {
                                        let variantsChoiceItem = `<div class="tl-discount-item-list">
                                                            <span style="display:none" class="tl-discount-item-index tl-discount-item-${discount.id}-${tier.minimum}">Item #${i + 1}</span>
                                                            <select style="display: none" onchange="window.tlDiscounts.selectDeal(${tier.minimum}, \'${discount.id}\', ${tier.off}, \'${discount.value_type}\')" class="tl-discount-variants-list tl-discount-variants-list-${discount.id}-${tier.minimum}">`
                                        this.variants.map((variant) => variantsChoiceItem += `<option class="tl-discount-variants-choices-${discount.id}-${tier.minimum}" value="${variant.id}">${variant.title}</option>`)
                                        variantsChoiceItem += "</select></div>";
                                        variantsChoiceList += variantsChoiceItem;
                                    }
                                }
                            }

                            discountHTML += `<label onclick="window.tlDiscounts.changeStyleRadioButton(${discount.id}, ${tier.minimum})" class="label-for-${discount.id}-tier-${tier.minimum} label-tl-discount" for="${discount.id}-tier-${tier.minimum}">
                                            <div class="tl-discount-item" onclick="window.tlDiscounts.selectDeal(${tier.minimum}, \'${discount.id}\', ${tier.off}, \'${discount.value_type}\')" >
                                                    <input style="display: none" type="radio" name="tl-discounts" id="${discount.id}-tier-${tier.minimum}"/>
                                                    <div class="tl-discount-radio-btn"></div>
                                                    <div class="tl-discount-tier-amount-infor">
                                                        <div>
                                                            <span>${tier.inforText}</span>
                                                        </div>
                                                        <div>
                                                            <span class="tl-discounts-total-price-${discount.id}-tier-${tier.minimum}">${discount.value_type === "percentage" ? this.formatMoney(this.variants[0].price * tier.minimum / 100 * (100 - tier.off)) : ((this.variants[0].price * tier.minimum - (+tier.off * 100)) < 0 ? this.formatMoney(0) : this.formatMoney((this.variants[0].price * tier.minimum - (+tier.off * 100)*this.currencyRate)))}</span>
                                                            <span><del class="tl-discounts-total-del-price-${discount.id}-tier-${tier.minimum}">${this.formatMoney(this.variants[0].price * tier.minimum)}</del></span>
                                                        </div>
                                                    </div>
                                            </div>
                                            <div class="tl-variants-choice-list">`
                            discountHTML += variantsChoiceList;
                            discountHTML += `</div>
                                                <div style="display:none" class="tl-discounts-grab-button tl-grab-discount-btn-${discount.id}-${tier.minimum}" onclick="window.tlDiscounts.addVariantToCart()">
                                                <span style="cursor: pointer" class="tl-discounts-grab-button-link">
                                                <span>${discount.addToCartText}</span>
                                                <span>
                                                    <svg width="66px" height="23px" viewBox="0 0 66 43" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                    <g id="arrow" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                                        <path class="one" d="M40.1543933,3.89485454 L43.9763149,0.139296592 C44.1708311,-0.0518420739 44.4826329,-0.0518571125 44.6771675,0.139262789 L65.6916134,20.7848311 C66.0855801,21.1718824 66.0911863,21.8050225 65.704135,22.1989893 C65.7000188,22.2031791 65.6958657,22.2073326 65.6916762,22.2114492 L44.677098,42.8607841 C44.4825957,43.0519059 44.1708242,43.0519358 43.9762853,42.8608513 L40.1545186,39.1069479 C39.9575152,38.9134427 39.9546793,38.5968729 40.1481845,38.3998695 C40.1502893,38.3977268 40.1524132,38.395603 40.1545562,38.3934985 L56.9937789,21.8567812 C57.1908028,21.6632968 57.193672,21.3467273 57.0001876,21.1497035 C56.9980647,21.1475418 56.9959223,21.1453995 56.9937605,21.1432767 L40.1545208,4.60825197 C39.9574869,4.41477773 39.9546013,4.09820839 40.1480756,3.90117456 C40.1501626,3.89904911 40.1522686,3.89694235 40.1543933,3.89485454 Z" fill="#FFFFFF"></path>
                                                        <path class="two" d="M20.1543933,3.89485454 L23.9763149,0.139296592 C24.1708311,-0.0518420739 24.4826329,-0.0518571125 24.6771675,0.139262789 L45.6916134,20.7848311 C46.0855801,21.1718824 46.0911863,21.8050225 45.704135,22.1989893 C45.7000188,22.2031791 45.6958657,22.2073326 45.6916762,22.2114492 L24.677098,42.8607841 C24.4825957,43.0519059 24.1708242,43.0519358 23.9762853,42.8608513 L20.1545186,39.1069479 C19.9575152,38.9134427 19.9546793,38.5968729 20.1481845,38.3998695 C20.1502893,38.3977268 20.1524132,38.395603 20.1545562,38.3934985 L36.9937789,21.8567812 C37.1908028,21.6632968 37.193672,21.3467273 37.0001876,21.1497035 C36.9980647,21.1475418 36.9959223,21.1453995 36.9937605,21.1432767 L20.1545208,4.60825197 C19.9574869,4.41477773 19.9546013,4.09820839 20.1480756,3.90117456 C20.1501626,3.89904911 20.1522686,3.89694235 20.1543933,3.89485454 Z" fill="#FFFFFF"></path>
                                                        <path class="three" d="M0.154393339,3.89485454 L3.97631488,0.139296592 C4.17083111,-0.0518420739 4.48263286,-0.0518571125 4.67716753,0.139262789 L25.6916134,20.7848311 C26.0855801,21.1718824 26.0911863,21.8050225 25.704135,22.1989893 C25.7000188,22.2031791 25.6958657,22.2073326 25.6916762,22.2114492 L4.67709797,42.8607841 C4.48259567,43.0519059 4.17082418,43.0519358 3.97628526,42.8608513 L0.154518591,39.1069479 C-0.0424848215,38.9134427 -0.0453206733,38.5968729 0.148184538,38.3998695 C0.150289256,38.3977268 0.152413239,38.395603 0.154556228,38.3934985 L16.9937789,21.8567812 C17.1908028,21.6632968 17.193672,21.3467273 17.0001876,21.1497035 C16.9980647,21.1475418 16.9959223,21.1453995 16.9937605,21.1432767 L0.15452076,4.60825197 C-0.0425130651,4.41477773 -0.0453986756,4.09820839 0.148075568,3.90117456 C0.150162624,3.89904911 0.152268631,3.89694235 0.154393339,3.89485454 Z" fill="#FFFFFF"></path>
                                                    </g>
                                                    </svg>
                                                </span> 
                                                </span>
                                            </div>
                                        </label>
                                    `;
                        })
                    }
                    discountHTML += "</div>";
                    discountsHTML += discountHTML;
                } else {
                    let discountHTML = `<div class="tl-discount-tier-container">
                                    <p class="tl-discount-title">${discount.title}</p>`;
                    discount.discountTiers.map((tier) => {
                        let priceFrom;
                        let realPrice;
                        let discountedPrice;
                        let minPrice = parseInt(this.product.priceMin);
                        let maxPrice = parseInt(this.product.priceMax);

                        if (minPrice !== maxPrice) {
                            if (discount.value_type === "percentage") {
                                priceFrom = this.formatMoney(minPrice * tier.minimum / 100 * (100 - tier.off));
                            } else {
                                priceFrom = (minPrice * tier.minimum - (+tier.off * 100)) < 0 ? this.formatMoney(0) : this.formatMoney(minPrice * tier.minimum - (+tier.off * 100));
                            }
                            realPrice = `From ${this.formatMoney(minPrice * tier.minimum)}`;
                            discountedPrice = `From ${priceFrom}`;
                        } else {
                            if (discount.value_type === "percentage") {
                                discountedPrice = this.formatMoney(this.variants[0].price * tier.minimum / 100 * (100 - tier.off));
                            } else {
                                discountedPrice = (this.variants[0].price * tier.minimum - (+tier.off * 100)) < 0 ? this.formatMoney(0) : this.formatMoney((this.variants[0].price * tier.minimum - (+tier.off * 100)*this.currencyRate));
                            }
                            realPrice = `${this.formatMoney(this.variants[0].price * tier.minimum)}`;
                        }

                        discountHTML += `<label>
                                    <div class="tl-discount-item">
                                        <div class="tl-discount-tier-amount-infor">
                                                <div>
                                                    <div class="tl-discount-not-interact-infor">
                                                        <span>${tier.inforText}</span>
                                                    </div>
                                                </div>
                                                <div>
                                                    <span class="tl-discounts-total-price-${discount.id}-tier-${tier.minimum}">${discountedPrice}</span>
                                                    <span><del class="tl-discounts-total-del-price-${discount.id}-tier-${tier.minimum}">${realPrice}</del></span>
                                                </div>
                                        </div>
                                    </div>
                                </label>`;
                    })
                    discountHTML += "</div>";
                    discountsHTML += discountHTML;
                }

            })
            this.discountsContainerHTML.innerHTML += discountsHTML;

            if (this.discountsGroup.every(discount => discount.customer_eligibility_type === "logged-in") && !this.isLoggedIn) {
                // this.grabDiscountButton.style.display = "none";
                let buttons = document.querySelectorAll(".tl-discounts-grab-button");
                buttons.forEach(ele => ele.style.display = "none");
            }
            else if (!this.chooseDefaultDeal) {
                for (let i = 0; i < this.discountsGroup.length; i++) {
                    if (this.discountsGroup[i].customer_eligibility_type === "logged-in" && !this.isLoggedIn) {
                        continue;
                    }
                    if (this.discountsGroup[i].layout_type === "allow_interact") {
                        this.selectDeal(this.discountsGroup[i].discountTiers[0].minimum, this.discountsGroup[i].id, this.discountsGroup[i].discountTiers[0].off, this.discountsGroup[i].value_type);
                        document.getElementById(`${this.discountsGroup[i].id}-tier-${this.discountsGroup[i].discountTiers[0].minimum}`).checked = true;
                        this.changeStyleRadioButton(this.discountsGroup[i].id, this.discountsGroup[i].discountTiers[0].minimum);
                        this.chooseDefaultDeal = true;
                        break;
                    }
                }
            }
            let displaySettings = this.discountsGroup[this.discountsGroup.length - 1].display_settings ? JSON.parse(this.discountsGroup[this.discountsGroup.length - 1].display_settings) : this.defaultDiscountStyle;
            this.changeStyle(displaySettings);
        }
    }
}
window.tlDiscounts = window.tlDiscounts || new DiscountsApplyOnVariant(tlDiscountVariants, tlDiscountCustomerTags, tlDiscountProduct, tlDiscountIsLoggedIn)